import { atom } from 'recoil'

export const messageState = atom({
  key: 'TextVersion__messageState',
  default: {
    idMessage: 0,
    name: '',
    plainText: '',
    isDirty: false
  }
})
